import { useUserInformationContext } from 'contexts/userContext';
import React from 'react';
import { Redirect } from 'react-router';
import { useTranslation } from 'react-i18next';

import BackdropLoading from '../../common/BackdropLoading';

type PageCheckerIsOnboardedProps = {
  render: () => React.ReactElement;
};

const PageCheckerIsOnboarded = ({ render }: PageCheckerIsOnboardedProps) => {
  const { isCurrentUserLoading, currentUser } = useUserInformationContext();
  const { t } = useTranslation();

  if (isCurrentUserLoading) {
    return <BackdropLoading open loadingText={t('common:loading')} />;
  }

  if (currentUser && currentUser.onboarded) {
    return <Redirect to="/orders" />;
  }

  return render();
};

export default PageCheckerIsOnboarded;
